import { Injectable } from '@angular/core';
import { menu } from '../menu/menu';

declare var $: any;


@Injectable()
export class SettingsService {

    public user: any;
    public app: any;
    public layout: any;

    constructor() {

        // User Settings
        // -----------------------------------
        this.user = JSON.parse(localStorage.getItem('user')) || {};

        // App Settings
        // -----------------------------------
        this.app = {
            name: 'Lea - Eveasoft ',
            description: 'Tous droits réservés',
            year: ((new Date()).getFullYear())
        };

        // Layout Settings
        // -----------------------------------
        this.layout = {
            isFixed: true,
            isCollapsed: false,
            isBoxed: false,
            isRTL: false,
            horizontal: false,
            isFloat: false,
            asideHover: false,
            theme: null,
            asideScrollbar: false,
            isCollapsedText: false,
            useFullLayout: false,
            hiddenFooter: false,
            offsidebarOpen: false,
            asideToggled: false,
            viewAnimation: 'ng-fadeInUp'
        };

    }

    getAppSetting(name) {
        return name ? this.app[name] : this.app;
    }
    getUserSetting(name) {
        // TODO a paramétrer en BDD par utilisateur
        // console.log('getUserSetting', name);
        if (name && name === 'list.limit') {
            return 20; // nombre d'éléments dans les listes, undefined pour retirer la limite ne fonctionne pas par paramètre => 1000
        }
        return name ? this.user[name] : this.user;
    }
    getLayoutSetting(name) {
        return name ? this.layout[name] : this.layout;
    }

    setAppSetting(name, value) {
        if (typeof this.app[name] !== 'undefined') {
            this.app[name] = value;
        }
    }
    setUserSetting(user: any) {
        this.user = user;
        localStorage.setItem('user', JSON.stringify(this.user));
    }
    removeUserSetting() {
        localStorage.setItem('user', null);
    }

    setLayoutSetting(name, value) {
        if (typeof this.layout[name] !== 'undefined') {
            return this.layout[name] = value;
        }
    }

    toggleLayoutSetting(name) {
        return this.setLayoutSetting(name, !this.getLayoutSetting(name));
    }

    /**
     *
     * ACCES AUX DROITS UTILISATEURS
     *
     */
    private getFonctionalite(name: string) {
        return (this.user.listeFonctionnalites || [])
        .filter(item => item.fonctionnalite === name);
    }
    // Gestion de l'affichage des menus
    isUserMenuAllowed(menu: string, acces: string = 'isLecture') {
        // console.log('isUserMenuAllowed', menu, acces);
        if (!menu) return true;
        // QUICKFIX: Admin right for parametrage is wrong (isLecture = false)
        // if (menu === 'FAMILLE' || menu === 'PARAMETRAGE') return true;

        const fonctionnalite = this.getFonctionalite(menu);
        // console.log('isUserMenuAllowed', menu, acces, !!fonctionnalite.length && fonctionnalite[0][acces]); // {fonctionnalite, facces: fonctionnalite[0][acces], flength: fonctionnalite.length});
        return !!fonctionnalite.length && fonctionnalite[0][acces];
    }

    // Gestion de la protection des routes
    isUserRouteAllowed(route: string) {
        // console.log('isUserRouteAllowed', route);
        let params = {menu: null, acces: null};
        if (route.indexOf('/eleve') >= 0) {
            // Univers Eleve
            if (route === '/eleve/create') {
                params = {
                    menu: 'ELEVE',
                    acces: 'isCreation',
                };
            } else if (route.indexOf('/eleve/edit') === 0) {
                params = {
                    menu: 'ELEVE',
                    acces: 'isModification',
                };
            } else if (route.indexOf('/eleve/delete') === 0) {
                params = {
                    menu: 'ELEVE',
                    acces: 'isSuppression',
                };
            } else {
                params = {
                    menu: 'ELEVE',
                    acces: 'isLecture',
                };
            }
        }

        if (route.indexOf('absence') >= 0) {
            // Univers Absence (élève)
            params.menu = 'ABSENCE_ELEVE';
            if (route === '/absence/create') {
                params.acces = 'isCreation';
            } else if (route.indexOf('/absence/edit') === 0) {
                params.acces = 'isModification';
            } else if (route.indexOf('/absence/delete') === 0) {
                params.acces = 'isSuppression';
            } else {
                params.acces = 'isLecture';
            }
        }

        if (route.indexOf('/famille') >= 0) {
            // Univers Famille
            if (route.startsWith('/famille/create')) {
                params = {
                    menu: 'FAMILLE',
                    acces: 'isCreation',
                };
            } else if (route.indexOf('/famille/edit') === 0) {
                params = {
                    menu: 'FAMILLE',
                    acces: 'isModification',
                };
            } else { // /famille ou /famille/show
                params = {
                    menu: 'FAMILLE',
                    acces: 'isLecture',
                };
            }
        }

        if (route.indexOf('/professeur') >= 0) {
            // Univers Professeur
            params.menu = 'PROFESSEUR';
            if (route.startsWith('/professeur/create')) {
                params.acces = 'isCreation';
            } else if (route.indexOf('/professeur/edit') === 0) {
                params.acces = 'isModification';
            } else {
                params.acces = 'isLecture';
            }
        }

        if (route.indexOf('/cours') >= 0) {
            // Univers Cours
            params.menu = 'COURS';
            if (route.startsWith('/cours/create')) {
                params.acces = 'isCreation';
            } else if (route.indexOf('/cours/edit') === 0) {
                params.acces = 'isModification';
            } else if (route.indexOf('/cours/delete') === 0) {
                params.acces = 'isSuppression';
            } else {
                params.acces = 'isLecture';
            }
        }

        if (route.indexOf('/planning') >= 0) {
            // Univers planning
            return true; // TODO
        }

        if (route.indexOf('/courriel') >= 0) {
            // Univers courriel
            params.menu = 'MODULE_MAIL';
            if (route.startsWith('/courriel/create')) {
                params.acces = 'isCreation';
            } else if (route.indexOf('/courriel/edit') === 0) {
                params.acces = 'isModification';
            } else {
                params.acces = 'isLecture';
            }
        }

        if (route.indexOf('/sms') >= 0) {
            // Univers Sms
            return true; // TODO
        }

        if (route.indexOf('/bulletin') >= 0) {
            // Univers bulletin
            return true; // TODO
        }

        if (route.indexOf('/examens') >= 0) {
            // Univers examens
            return true; // TODO
        }

        if (route.indexOf('/administration') >= 0) {
            // Univers administration
            if (route.startsWith('administration/factures')) {
                params.menu = 'FACTURATION';
                params.acces = 'isLecture';
            } else {
                return true; // TODO
            }
        }

        if (route.indexOf('/parametrage') === 0) {
            params = {
                menu: 'PARAMETRAGE',
                acces: 'isLecture',
            };
        }

        if (route.indexOf('/moncompte') === 0) {
            return true; // Tout le mond à accès à MonCompte (pour changer son mot de passe)
        }

        // console.log('params', params);
        // Les routes non paramétrées sont interdites
        if (params.menu === null) {
            return false;
        }
        return this.isUserMenuAllowed(params.menu, params.acces);

    }

    // VERIFICATION DES DROITS DANS UNE PAGE
    isUserMultipleSelectionAllowed() {
        return !!this.getFonctionalite('SELECTION_MULTIPLE');
    }


}



// WEBPACK FOOTER //
// /builds/eveasoft/lea/lea-front/src/app/core/settings/settings.service.ts